module.exports = "https://bin.bnbstatic.com/_next/static/images/mobileTitle-6dc26fef7b96709790b0bdbd3637e9ff.png";